<!-- =========================================================================================
    File Name: EmailSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="email__email-sidebar">
    <VuePerfectScrollbar class="email-scroll-area" id="informative-submenu-content-scroll" :settings="settings">
      <!-- <div class="px-6 flex flex-col" id="sidebar-contents"> -->
      <div class="" id="sidebar-contents">
        
        <div class="filter-label circle-toggle-submenu-no-fav">
          <feather-icon
            :class="{'btnVNavMenuMinToggler': !reduceSidebar}"
            class="mr-0 cursor-pointer"
            :icon="reduceSidebar ? 'CircleIcon' : 'DiscIcon'"
            svg-classes="stroke-current"
            @click="toggleReduceSidebar(!reduceSidebar)"
          />
        </div>
        <div v-if="reduceSidebar && getFavoritesContentList.length == 0" class="submenu-content-item" style="height: 45px;"></div>
        <div
          class="pl-4 ml-0 w-full items-center"
          v-for="(item, index) in content"
          :key="index"
          :class="{
            'disabled-item': !item.habilitado, 
            'stroke-current content-current' : isContentFilterSelected(item), 
            'reduce-item-custom': reduceSidebar && !item.isLabel, 
            'items-center cursor-pointer submenu-content-item': !item.isLabel,
            'justify-between': !hasReportType(item),
            'sidebar-item-with-reporttype': hasReportType(item),
            'sidebar-item-no-background': isOpenedReportType(item) && !reduceSidebar,
            'display-none': item.isLabel && reduceSidebar
            }"
          @click="selectCurrentContent(item)"
          @mouseover="displayStarIconOnMouseOver(item)"
          @mouseleave="displayStarIconOnMouseOver(null)"
        >
          <template v-if="item.isLabel && !reduceSidebar">
            <div class="filter-label filter-label-margin informative-label-custom">
              <span>{{item.text}}</span>
            </div>
          </template>
          <template v-else>
            <vx-tooltip :text="tooltipText(item)" :disabled="item.habilitado && !reduceSidebar" position="right">
              <div class="items-center sidebar-content-item">
                <feather-icon class="sidebar-content-item-icon" :icon="item.icone" :svgClasses="['h-6 w-6']"></feather-icon>
                <!-- <span class="sidebar-content-name" v-if="!reduceSidebar">{{getContentName(item)}}</span> -->
                <span class="sidebar-content-name" v-if="!reduceSidebar">
                  {{getFieldName('name', item)}}
                  <!-- ArrowDownIcon -->
                  <feather-icon 
                    :icon="getCurrentContentReportTypeIcon(item)" 
                    :svgClasses="['h-5 w-5']" 
                    class="cursor-pointer list-content-reporttype-icon" 
                    v-if="hasReportType(item) && !reduceSidebar" 
                    @click.stop="openReportTypeList(item)"
                  >
                  </feather-icon>
                </span>
               
                <!-- <feather-icon icon="StarIcon" :svgClasses="['h-4 w-4']" class="cursor-pointer favorite-content-icon favorite-content-selected" @click.stop="favoriteContent(item)" v-if="!reduceSidebar "></feather-icon> -->
                <feather-icon 
                  icon="StarIcon" 
                  :svgClasses="['h-4 w-4']" 
                  class="cursor-pointer favorite-content-icon" 
                  :class="{'favorite-content-selected': item.isFavorite}" 
                  @click.stop="!reduceSidebar && favoriteContent(item)" 
                  :disabled="reduceSidebar"
                  v-if="isAuthenticated && !reduceSidebar && ((itemHover.id == item.id && itemHover != null && item.habilitado && itemHover.id != null) || (isContentFilterSelected(item) && item.id != null )) || item.isFavorite "
                >
                </feather-icon>
                <!-- <feather-icon @click.stop="$emit('open-exclusive-content')" icon="LockIcon" class="favorite-content-icon" :svgClasses="['h-4 w-4']" v-if="item.isQuotes && !isAuthenticated"/> -->
                <!-- <div class="flex icons-details items-center" v-if="item.isQuotes && !isAuthenticated">
                </div> -->
              </div>
            </vx-tooltip>
            <!-- <VuePerfectScrollbar class="sidebar-reporttype-content" id="informative-submenu-content-scroll" :settings="settings" v-if="isOpenedReportType(item) && !reduceSidebar">
              <div 
                class="sidebar-reporttype-item"
                v-for="(reportType, index) in item.reportType"
                :key="index+1"
                :class="{'current': isCurrentReportTypeSelected(reportType)}"
                @click.stop="selectReportType(item, reportType)">
                <div class="flex items-center">
                  <span>{{reportType.name}}</span>
                </div>
              </div>
            </VuePerfectScrollbar> -->
            <VuePerfectScrollbar class="sidebar-reporttype-content" id="informative-submenu-content-scroll" :settings="settings" v-if="isOpenedReportType(item) && !reduceSidebar">
              <div 
                class="sidebar-reporttype-item"
                style="overflow-x: hidden;"
              >
                <div 
                  v-for="(reportTypeGroup, index) in item.reportType"
                  :key="index+1"
                  class="flex items-center"
                  style="flex-direction: column;"  
                >
                  <section 
                    v-if="reportTypeGroup.session"
                    style="font-weight: bold;"
                    class="section-report-type"
                    :class="{
                      'text-primary stroke-current content-current' : isReportTypeSelected(reportTypeGroup), 
                      'section-report-type-selected' : isOpenedReportTypeGroup(item), 
                    }"
                    @click.stop="openReportTypeGroupList(reportTypeGroup)"
                  >
                    <span style="color: #626262;">{{reportTypeGroup.session}}</span>
                    <feather-icon 
                      :icon="getCurrentReportTypeGroupIcon(reportTypeGroup)" 
                      :svgClasses="['h-5 w-5']" 
                      class="cursor-pointer list-content-reporttype-icon" 
                      v-if="!reduceSidebar && reportTypeGroup.session" 
                      style="color: #626262; width: auto"
                    >
                    </feather-icon>
                  </section>
                  <template v-if="openReportTypeGroups[reportTypeGroup.id]">
                    <span
                      v-for="(reportType, i) in reportTypeGroup.items"
                      class="report-type-item"
                      :key="i+1"
                      @click.stop="selectReportType(item, reportType)"
                      :class="{'report-type-item-selected': isCurrentReportTypeSelected(reportType), 'sidebar-reporttype-item-border': reportTypeGroup.session}"
                      style="margin-left: 15px;"
                    >{{reportType.name}}</span>
                  </template>
                  <span
                    v-for="(typesOfReportsWithoutGroups, j) in reportTypeGroup.typesOfReportsWithoutGroups"
                    class="report-type-item"
                    :key="j+1"
                    @click.stop="selectReportType(item, typesOfReportsWithoutGroups)"
                    :class="{'report-type-item-selected': isCurrentReportTypeSelected(typesOfReportsWithoutGroups), 'sidebar-reporttype-item-border': typesOfReportsWithoutGroups.name}"
                  >{{ typesOfReportsWithoutGroups.name }}</span>
                </div>
              </div>
            </VuePerfectScrollbar>
          </template>
        </div>
        <!-- End of Cotação -->
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {getCodeLang} from "@/helpers/locale-helper";
import localStorageHelper from '../../../helpers/local-storage-helper';
import translateFieldHelper from '../../../helpers/translate-field-helper';

export default {
  props: {
    reduceSidebar: {
      type: Boolean,
      required: true
    },
    content: {
      type: Array,
      required: true
    },
    isAuthenticated: Boolean
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3
      },
      previousContent: null,
      itemHover: {},
      currentContentOpenedReportType: null,
      openReportTypeGroups: {},
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    currentReportType() {
      return this.$store.state.currentReportType;
    },
    currentCommodity() {
      return this.$store.state.currentCommodity;
    },
    currentContent() {
      return this.$store.state.currentContent;
    },
    getFavoritesContentList() {
      const fav = this.$store.state.favoriteContent.find(i => i.commodity == Number(this.currentCommodity));
      if (fav) {
        return fav.content;
      }
      return [];
    }
  },
  methods: {
    selectFirstQuotesContent() {
      const quotesContent = this.content.find(item => item.isQuotes && item.habilitado);
      if (quotesContent) {
        this.selectCurrentContent(quotesContent, false);
      } else {
        console.log('[selectFirstQuotesContent] not found quotes content enabled');
      }
    },
    getFieldName(field, data) {
      return translateFieldHelper.getTranslateField(field, data);
    },
    isOpenedReportType(item) {
      if (this.currentContentOpenedReportType && item.id) {
        return this.currentContentOpenedReportType.id == item.id;
      }
      return false;
    },
    isOpenedReportTypeGroup(item) {
      return this.openReportTypeGroups[item.id] == true || false;
    },
    selectReportType(content, item) {
      console.log("[selectReportType]", item.id)
      // this.selectedFilter.reportType = item;
      this.$store.dispatch("updateCurrentReportType", item);

      if (!this.isContentFilterSelected(content)) {
        this.selectCurrentContent(content, false);
      } else {
        this.updateFilter();
      }
    },
    isCurrentReportTypeSelected(item) {
      if (this.currentReportType.id === item.id) {
        return true;
      }
      return false;
    },
    getCurrentContentReportTypeIcon(item) {
      if (this.isOpenedReportType(item)) {
        return 'ChevronUpIcon';
      }
      return 'ChevronDownIcon';
    },
    getCurrentReportTypeGroupIcon(item) {
      if (this.openReportTypeGroups[item.id] == true) {
        return 'ChevronUpIcon';
      }
      return 'ChevronDownIcon';
    },
    openReportTypeList(item) {
      if (this.isOpenedReportType(item)) {
        this.currentContentOpenedReportType = null;
      } else {
        this.currentContentOpenedReportType = item;
      }
    },
    openReportTypeGroupList(item) {
      this.$set(this.openReportTypeGroups, item.id, !this.openReportTypeGroups[item.id]);
  },
    // hasReportType(item) {
    //   if (item.reportType) {
    //     return item.reportType.length > 0;
    //   }
    //   return false;
    // },
    hasReportType(item) {
      if (Array.isArray(item.reportType)) {
        return item.reportType.some(rt => 
          (Array.isArray(rt.typesOfReportsWithoutGroups) && rt.typesOfReportsWithoutGroups.length > 0) ||
          (Array.isArray(rt.items) && rt.items.length > 0)
        );
      }
      return false;
    },
    getContentName(item) {
      if (item.id) {
        return item.nome;
      }
      return item[`nome${getCodeLang(localStorageHelper.getLocale())}`];
    },
    displayStarIconOnMouseOver(content) {
      if (content) {
        if (!content.id) {
          this.itemHover = {}
        } else {
          this.itemHover = content;
        }
      } else {
        this.itemHover = {}
      }
    },
    favoriteContent(content) {
      // console.log(content);
      if (!content.id) {
        return;
      }
      const scroll = document.querySelector("#informative-submenu-content-scroll");
      scroll.scrollTop = 0;
      setTimeout(() => {
        // this.$store.dispatch("updateFavoriteMenuContent", {commodity: Number(this.currentCommodity), content: content});
        this.updateListContentByFavorite(content);
      }, 500);
    },
    tooltipText(item) {
      if (item.habilitado) {
        return item.nome;
      }

      if (this.reduceSidebar) {
        return `${item.nome} - ${this.$t('MENU').NoRights}`;
      }
      return this.$t('MENU').NoRights;
    },
    openQuotes(value) {
      this.$emit("openQuotesPage", value);
    },
    updateFilter() {
      this.$emit("updateFilter", { previousContent: this.previousContent });
    },
    selectCurrentContent(content, selectAllReportType = true) {
      if (content.isLabel) {
        return;
      }
      if (content.isQuotes && !this.isAuthenticated) {
        this.$emit('open-exclusive-content');
        return;
      }
      if (content.isQuotes && this.windowWidth <= 1600) {
        this.$emit("toggleReduceSidebar", true);
      }
      this.openQuotes(false);
      if (!content.habilitado) {
        this.$emit('open-user-rights-modal', content);
        return;
      }
      // if (!this.previousContent && this.currentContent.id != content.id) {
      //   this.previousContent = JSON.parse(JSON.stringify(this.currentContent));
      // }
      if (this.currentContent && this.currentContent.id !== content.id) {
        this.previousContent = { ...this.currentContent }; 
      }

      if (selectAllReportType) {
        // this.selectedFilter.reportType = {id: null};
        this.$store.dispatch("updateCurrentReportType", { id: null });
      }
      if (this.hasReportType(content) && !this.reduceSidebar) {
        this.openReportTypeList(content);
        // this.$store.dispatch("updateCurrentReportType", { id: null });
      } else {
        this.currentContentOpenedReportType = null;
      }
      if (this.hasReportType(content) && !this.reduceSidebar) {
        this.openReportTypeGroupList(content);
        // this.$store.dispatch("updateCurrentReportType", { id: null });
      } else {
        this.currentContentOpenedReportTypeGroup = null;
      }

      this.$store.dispatch("updateCurrentContent", content);

      this.$forceUpdate();
      this.updateFilter();
    },
    isContentFilterSelected(item) {
      if (item.isLabel) {
        return false
      }
      if (this.currentContent) {
        return this.currentContent.id == item.id;
      }
      return false;
    },
    isReportTypeSelected(item) {
      if (this.currentReportType) {
        return this.currentReportType.id == item.id;
      }
      return false;
    },
    toggleReduceSidebar() {
      this.$emit("toggleReduceSidebar", !this.reduceSidebar);
    },
    updateListContentByFavorite(content) {
      this.$emit("updateListContent", content);
      this.$forceUpdate();
    },
  },
  components: {
    VuePerfectScrollbar
  },
  mounted() {
    // listen to the event
    // EventBus.$on(AppConstants.BUS_EVENT_CLEAR_FILTER, () => {});
    // if (this.content.length > 0) {
    //   this.$store.dispatch("updateCurrentContent", this.content.find(item => !item.isLabel));
    // }
    // this.selectedFilter.content = this.content[0];
  },
  created() {},
  beforeDestroy() {
    // stop listening event
    // EventBus.$off(AppConstants.BUS_EVENT_CLEAR_FILTER);
  }
};
</script>

<style lang="scss">
</style>
